/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_First_Name_HelpInputs */

const en_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the user's first name`)
};

const fr_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez le prénom de l’utilisateur`)
};

const de_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie den Vornamen des Benutzers ein`)
};

const it_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il nome dell'utente`)
};

const ru_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите имя пользователя`)
};

const es_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca el nombre del usuario`)
};

const zh_cn2_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入用户的名字`)
};

const ja_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーの名を入力してください`)
};

const hi_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता का पहला नाम दर्ज करें`)
};

const pt_pt2_team_manager_first_name_help = /** @type {(inputs: Team_Manager_First_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite o primeiro nome do usuário`)
};

/**
* | output |
* | --- |
* | "Enter the user's first name" |
*
* @param {Team_Manager_First_Name_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_first_name_help = /** @type {((inputs?: Team_Manager_First_Name_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_First_Name_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_first_name_help(inputs)
	if (locale === "de") return de_team_manager_first_name_help(inputs)
	if (locale === "it") return it_team_manager_first_name_help(inputs)
	if (locale === "ru") return ru_team_manager_first_name_help(inputs)
	if (locale === "es") return es_team_manager_first_name_help(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_first_name_help(inputs)
	if (locale === "ja") return ja_team_manager_first_name_help(inputs)
	if (locale === "hi") return hi_team_manager_first_name_help(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_first_name_help(inputs)
	return en_team_manager_first_name_help(inputs)
});